import { loadScript, loadLink } from "../../utils";

class Map {
  constructor(DOMelement, store, onMarkerClickCallback,) {
    try {
      this.map = null;
      this.el = DOMelement;
      this.mapId = this.el.id;
      this.store = store;

      this.data_geo_attr = this.el.getAttribute("data-geo");
      this.scriptID = document.querySelector(`#${this.data_geo_attr}`);
      this.scriptData = this.scriptID.innerText;
      this.mapData = JSON.parse(this.scriptData);
      this.geolocationsData = this.mapData.geolocations;
      this.onMarkerClickCallback = onMarkerClickCallback;
      this.createMarker = this.createMarker.bind(this);
      this.init = this.init.bind(this);
      this.observMap = this.observMap.bind(this);
      this.observer = new IntersectionObserver(this.observMap, {
        threshold: [0],
      });
    
      if(this.mapId.includes('itinerary-sd-map')){
        this.mapCoord = {};
        this.similarLocIndexes = [];
        
        this.mapData.geolocations.forEach((item, i) => {
          const key = `${item.latitude},${item.longitude}`;
          //if the entry doesn't exist yet in mapcoord object, create it with lat and lon as key and an array called indexes;
          if (!this.mapCoord[key]) {
            this.mapCoord[key] = {
              indexes: []
            };
          }
          //push index of the location in its specific lon and lat entry in mapCoord
          this.mapCoord[key].indexes.push(i);
        });
        //loop through each mapCoord key(property names of object) to check if the number of indexes in it is bigger than 1. if so push 
        for (const key in this.mapCoord) {
          if (this.mapCoord[key].indexes.length > 1) {
            this.similarLocIndexes.push({
              indexes: this.mapCoord[key].indexes,
            });
          }
        }
      }

      this.popUps = [];
      this.init();
    } catch (error) {
      console.log(error);
    }
  }

  observMap(entries) {
    if (entries[0].isIntersecting === true) {
      this.initMapbox().then((mapbox) => {
        this.mapbox = mapbox;
        this.mapbox.accessToken =
          "pk.eyJ1Ijoic2NvdHRkdW5uIiwiYSI6ImNsZGVxZ24xOTBiYmIzcG81dnl4ZG0zNTkifQ.pYKbvO-0uLYHwwpu2CHvDQ";
        this.map = new this.mapbox.Map({
          container: this.el.id,
          style: "mapbox://styles/mapbox/light-v10?optimize=true",
          zoom: 5,
        });
        if (this.geolocationsData && this.geolocationsData.length) {
          this.geolocationsData.map(this.createMarker);

          let latitude = null;
          let longitude = null;

          if (this.el.getAttribute("data-latitude") && this.el.getAttribute("data-longitude")) {
            latitude = this.el.getAttribute("data-latitude");
            longitude = this.el.getAttribute("data-longitude");
          }
          else {
            longitude = this.geolocationsData[0].longitude;
            latitude = this.geolocationsData[0].latitude;
          }

          this.map.flyTo({
            center: [longitude, latitude],
          });
        }
        this.observer.disconnect();
        this.map.addControl(new this.mapbox.NavigationControl());
      });
    }
  }

  init() {
    this.observer.observe(this.el);
  }

  createMarker(data, idx) {
    let latitude = null,
        longitude = null,
        similarLocArrIdx = null, 
        similarLocElInnerIdx = null;

    if (this.el.getAttribute("data-latitude") && this.el.getAttribute("data-longitude")) {
      latitude = this.el.getAttribute("data-latitude");
      longitude = this.el.getAttribute("data-longitude");
    }
    else {
      longitude = data.longitude;
      latitude = data.latitude;
    }

    const el = document.createElement("div");
    el.className = "marker";
   
    if(this.similarLocIndexes && this.similarLocIndexes.length > 0 && this.similarLocIndexes.some(item => item.indexes.includes(idx))){
        similarLocArrIdx = this.similarLocIndexes.findIndex(item => item.indexes.includes(idx));
        similarLocElInnerIdx = this.similarLocIndexes[similarLocArrIdx].indexes.indexOf(idx);

        el.classList.add('overlapped', `el-${similarLocElInnerIdx}`);
    }
  
    const number = document.createElement("span");
    number.className = "sd-body1";
    number.innerHTML = idx + 1;
    const arrow = document.createElement("span");
    arrow.className = "arrow-down";
    el.appendChild(number);
    el.appendChild(arrow);

    const marker = new this.mapbox.Marker(el)
      .setLngLat([longitude, latitude])
      .addTo(this.map);

    if (this.onMarkerClickCallback) {
      marker
        .getElement()
        .addEventListener("click", () => this.onMarkerClickCallback(data, idx));
    }
  }

  initMapbox() {
    function getMapbox() {
      return new Promise((resolve, reject) => {
        if (window.mapboxgl) {
          resolve(window.mapboxgl);
        } else {
          reject();
        }
      });
    }

    return Promise.all([
      loadScript("//api.mapbox.com/mapbox-gl-js/v2.1.1/mapbox-gl.js"),
      loadLink("//api.mapbox.com/mapbox-gl-js/v2.1.1/mapbox-gl.css"),
    ])
      .then(() => getMapbox().then((mapbox) => mapbox))
      .catch(console.error);
  }
}

export default Map;
